/* eslint-disable react/prop-types */
import React, { useState, createContext, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Creators } from 'store/ducks/queue';

export const SyncContext = createContext();

const SyncContextProvider = ({ children }) => {
  const dispatch = useDispatch();

  const [inEditableContext, setInEditableContext] = useState(0);
  const [lock, setLock] = useState(false);
  useEffect(() => {
    setLock(localStorage.getItem('lock'));
  }, []);
  const token = useSelector(state => state.user.auth.token);
  useEffect(() => {
    if (token) {
      unlockSync();
    }
  }, [token]);
  const [automaticSync, setAutomaticSync] = useState(
    !localStorage.getItem('lock') && !inEditableContext,
  );
  const [syncProcess, setSyncProcess] = useState(null);

  useEffect(() => {
    setAutomaticSync(!inEditableContext && !lock);
    if (!inEditableContext && !lock) {
      dispatch(Creators.unlock());
    } else {
      dispatch(Creators.lock());
    }
  }, [inEditableContext, lock, dispatch]);

  function addEditableContext() {
    setInEditableContext(inEditableContext + 1);
  }

  function removeEditableContext() {
    setInEditableContext(inEditableContext > 0 ? inEditableContext - 1 : 0);
  }

  const lockSync = () => {
    localStorage.setItem('lock', 'true');
    setLock(true);
  };

  const unlockSync = () => {
    localStorage.removeItem('lock');
    setLock(false);
  };

  const runSyncProcess = () => {
    if (syncProcess) {
      return;
    }
    dispatch(Creators.ping());
    setSyncProcess(
      window.setInterval(() => {
        dispatch(Creators.ping());
      }, 10000),
    );
  };

  const stopSyncProcess = () => {
    if (syncProcess) {
      window.clearInterval(syncProcess);
    }
    setSyncProcess(null);
  };

  return (
    <SyncContext.Provider
      value={{
        automaticSync,
        lock,
        inEditableContext,
        syncProcess,
        lockSync,
        unlockSync,
        runSyncProcess,
        stopSyncProcess,
        addEditableContext,
        removeEditableContext,
      }}
    >
      {children}
    </SyncContext.Provider>
  );
};

export default SyncContextProvider;
